import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Override20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.03039 2.96967L16.0607 10L9.03039 17.0303L7.96973 15.9697L13.1894 10.75L1 10.75V9.25L13.1894 9.25L7.96973 4.03033L9.03039 2.96967Z'
      fill='currentColor'
    />
    <path d='M18.25 3.5V16.5H19.75V3.5L18.25 3.5Z' fill='currentColor' />
  </Svg>
);

Override20.displayName = 'Override20';
export default Override20;
